<template>
  <CrudForm :title="title" :labelSubmit="label_submit" :storeName="storeName" parentStoreName="Users" :submit="submit"
    :status="status" :canCancel="false">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col cols="12">
              <ValidationProvider ref="name" rules="required" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.type" label="Segmento" :items="types">
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="user" rules="required" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.users" :items="usersCopy" attach chips label="Users"
                  :item-text="(row) => `${row.name || ''} ${row.last_name || ''}`
                    " :disabled="!data.type" item-value="id" multiple search-input>
                  <template #prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field v-model="searchUser" placeholder="Search" @input="searchUsers"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                    <v-list-item @click="clickSelectAll()">
                      <v-list-item-action>
                        <v-checkbox v-model="selectAll" :indeterminate="selectAll === null" :input-value="false"
                          hide-details @click="clickSelectAll()"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Seleccionar todos</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <v-text-field label="Title" :error-messages="errors" v-model="data.title" />

                <!--                <v-textarea
                  :error-messages="errors"
                  v-model="data.question"
                  solo
                >
                </v-textarea>-->
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <label>Body Push</label>
              <ValidationProvider ref="answer" rules="required" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.body_push" solo rows="8">
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="send_email" rules="" v-slot="{ errors }">
                <v-checkbox :error-messages="errors" v-model="data.send_email" label="Enviar como email"
                  value="on"></v-checkbox>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="url" rules="" v-slot="{ errors }">
                <v-text-field label="Hora" :error-messages="errors" type="time" v-model="data.hour"
                  suffix="Hora"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <v-menu ref="menu_dead_line" v-model="menu_expire_date" :close-on-content-click="false"
                transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider ref="date" rules="" v-slot="{ errors }">
                    <v-text-field v-model="data.date" label="Fecha" prepend-icon="fas fa-calendar" readonly
                      v-bind="attrs" v-on="on" :error-messages="errors"></v-text-field>
                  </ValidationProvider>
                </template>
                <v-date-picker v-model="data.date" type="date" no-title scrollable
                  @change="menu_expire_date = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row v-if="data.send_email">
            <v-col>
              <label>Body Email</label>
              <ValidationProvider ref="answer" rules="required" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.body_email" solo rows="8">
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="url" rules="" v-slot="{ errors }">
                <v-text-field label="Url" :error-messages="errors" v-model="data.url" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="picture" rules="" v-slot="{ errors }">
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg"
                  placeholder="Imagen de Perfil" prepend-icon="fas fa-camera" label="" :multiple="false"
                  :onSelectedPicture="onSelectedPicture"></Upload>
                <v-img :src="picture" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import swal from "sweetalert";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, Upload, CrudForm },
  computed: {
    ...mapState({
      status: (state) => state.Faqs.status,
      users: (state) => state.Users.list,
    }),
  },
  watch: {
    expire_date(val) {
      this.expire_date = val;
      this.data.expire_date = this.formatDateForSave(val);
    },
    "data.users"(newValue) {
      if (newValue.length === this.usersCopy.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    "data.type": {
      async handler(newValue) {
        this.data.users = [];
        let filter_type = { type: newValue };
        if (newValue === "all_users") {
          filter_type = {};
        }
        await this.$store.dispatch("Users/getListAll", {
          show_all: "enable",
          ...filter_type,
          sorting_column: "name",
          sorting_order: "asc",
        });
        this.usersCopy = this.users;
      },
    },
  },
  async created() {
    await this.$store.dispatch("Users/getListAll", {
      show_all: "enable",
      sorting_column: "name",
      sorting_order: "asc",
    });
    this.usersCopy = this.users;
  },
  data() {
    return {
      storeName: "Send_notifications",
      label_submit: "Send Notification",
      title: "Notificaciones",
      show: true,
      filteredAttributes: ["picture"],
      picture: "",
      types: [
        {
          text: "HOSTS",
          value: "host",
        },
        {
          text: "HOSTS QUE TIENEN AUTO",
          value: "host_with_car",
        },
        {
          text: "CONDUCTORES",
          value: "driver",
        },
        {
          text: "USUARIOS QUE NO TIENEN NI AUTO NI SPOT",
          value: "user_without_car_and_spot",
        },
        {
          text: "USUARIOS NUEVOS DEL DÍA‌",
          value: "new_user",
        },
        {
          text: "USUARIOS CON SPOT RECHAZADO‌",
          value: "user_with_rejected_spot",
        },
        {
          text: "TODOS LOS USUARIOS",
          value: "all_users",
        },
      ],
      data: {
        title: "",
        body_push: "",
        body_email: "",
        users: [],
        picture: undefined,
        type: "",
        send_email: '',
        hour: '',
        date: null,
        programmed: true,
      },
      date: '',
      menu_expire_date: false,
      selectAll: false,
      searchUser: "",
      usersCopy: [],
    };
  },

  methods: {
    async submit() {
      const self = this;
      let valid = await self.$refs.validator.validate();

      if (valid) {
        let saveUrl = this.$route.params.id
          ? `${this.storeName}/update`
          : `${this.storeName}/create`;
        self.$store
          .dispatch(saveUrl, self.data)
          .then(function () {
            swal("Send Notification", "Successful!!", "success", {
              buttons: false,
              timer: 3000,
            });
            self.$router.push(self.buildRootUrl());
          })
          .catch(function (response) {
            swal("Error to Send Notification", "Error", "error", {
              buttons: false,
              timer: 3000,
            });
            for (const i in response.errors) {
              try {
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
      }
    },
    clickSelectAll() {
      if (!this.selectAll) {
        this.data.users = this.usersCopy.map((user) => user.id);
      } else {
        this.data.users = [];
      }
    },
    searchUsers() {
      if (!this.searchUser) {
        this.usersCopy = this.users;
      }

      this.usersCopy = this.users.filter((user) => {
        let full_name = `${user.name || ""} ${user.last_name || ""}`;
        return (
          full_name.toLowerCase().indexOf(this.searchUser.toLowerCase()) > -1
        );
      });
    },
    onSelectedPicture(file) {
      const self = this;
      this.data.picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.picture = fr.result;
      };
      fr.onerror = function () {
        self.picture = "";
      };
      fr.readAsDataURL(this.data.picture);
    },
  },
};
</script>
